<rect
    data-date={stringifyDate(date)}
    data-value={value}
    fill={color}
    height={size}
    rx={radius}
    width={size}
    x={x}
    y={y}
/>

<script>
import { stringifyDate } from '../utils/date';

export let color;
export let date;
export let radius;
export let size;
export let value;
export let x;
export let y;
</script>
